export default __webpack_public_path__ + "static/media/gallery-7-3.37548682.webp";